// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2724":"f2da2b5a0883b518","3142":"d283b895985ff5b7","9226":"fe66ba4c646dad2b"}[chunkId] + ".css";
};